import React from 'react';
import {Box, Icon, Heading} from '@chakra-ui/react';
import {FaRunning} from 'react-icons/fa';
const Unauthorized = () => {
  return (
    <Box textAlign={'center'}>
      <Icon as={FaRunning} w="40%" h="40%" p="7" />
      <Heading>Slow Down!</Heading>
      <Heading> Unauthorized to view this page.</Heading>
    </Box>
  );
};

export default Unauthorized;
